const saveColumnsToLocalStorage = (authorizedUserId, newColumnsToDisplay, columnsType) => {
  const storagedData = JSON.parse(localStorage.getItem(authorizedUserId));
  const dataToSave = {...storagedData, [columnsType]: newColumnsToDisplay}

  localStorage.setItem(authorizedUserId, JSON.stringify(dataToSave));
}

export default saveColumnsToLocalStorage;